export default function ProjectDetailsStep({ onNext, onBack }) {
  return (
    <>
      <h3>Project Type</h3>

      <label><input type="checkbox" /> Administrative Support</label>
      <label><input type="checkbox" /> Bookkeeping</label>
      <label><input type="checkbox" /> Financial Reporting</label>
      <label><input type="checkbox" /> Budget Monitoring</label>
      <label><input type="checkbox" /> Business Process Support</label>

      <div className="actions">
        <button className="btn secondary" onClick={onBack}>Back</button>
        <button className="btn primary" onClick={onNext}>Next</button>
      </div>
    </>
  );
}
